import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import useTheme from '../hooks/useTheme';

export default function Topbar() {
  const theme = useTheme();

  return (
    <AppBar 
      position="fixed" 
      elevation={0} 
      sx={{ 
        zIndex: (theme) => theme.zIndex.drawer + 1, 
        background: theme.cardBackground, 
        color: theme.textColor, 
        boxShadow: 'none', 
        borderBottom: `1px solid ${theme.borderColor}`, 
        height: 64, 
        justifyContent: 'center' 
      }}
    >
      <Toolbar sx={{ minHeight: 64, px: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img src={theme.appLogo} alt="Logo" style={{ height: 32 }} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="body2" sx={{ color: theme.textSecondaryColor, fontWeight: 500 }}>
            {theme.appName}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
} 